import { Controller } from 'react-hook-form';
import { useSapphireMedia } from '../hooks';
import styled from 'styled-components';
import { NumberField } from '@sapphire-react/lab';
import type { NumberFieldProps } from '@sapphire-react/lab';
import { FormFieldProps } from '../types';

type Props = Omit<NumberFieldProps, 'name'> & {
  name: string;
} & FormFieldProps;

export function NumberFieldInput(props: Props) {
  const { control, name, rules, ...rest } = props;
  const { isExtraSmall, isSmall } = useSapphireMedia();

  return (
    <Wrapper>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({
          field: { ref: _ref, onChange, ...field },
          fieldState: { error },
        }) => (
          <NumberField
            {...field}
            size={isExtraSmall || isSmall ? 'md' : 'lg'}
            alignInputRight
            contextualHelp={rest.contextualHelp}
            data-test-id={`${name}-AmountInput`}
            onChange={(value) => {
              onChange(value);
            }}
            error={error?.message}
            {...rest}
          />
        )}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  label {
    display: inline;
  }
`;
